export const localStorageKey = {
  authToken: "authToken",
  userType: "userType",
};

export const screenPath = {
  chooseUser: "/",
  login: "/login",
  signup: "/signup",
  accountantSelectCompany: "/accountantSelectCompany",
  accountantInvoices: "/accountantInvoices",
  accountantEntries: "/accountantEntries",
  accountantReports: "/accountantReports",
  accountantEvents: "/accountantEvents",
  accountantDocuments: "/documentsAccountant",
  dashboardPage: "/dashboardPage",
  personalTaxPage: "/personalTaxPage",
  dashboardCompanyPage: "/dashboardCompanyPage",
  transactionCompanyPage: "/transactionCompanyPage",
  newInvoiceCompanyPage: "/newInvoiceCompanyPage",
  logExpensesCompanyPage: "/logExpensesCompanyPage",
  recordMileageCompanyPage: "/recordMileageCompanyPage",
  bankStatementCompanyPage: "/bankStatementCompanyPage",
  reportsCompanyPage: "/reportsCompanyPage",
  uploadDataCompanyPage: "/uploadDataCompanyPage",
  profileCompanyPage: "/profileCompanyPage",
  adminDashboard: "/adminDashboard",
  clientPage: "/clientPage",
  documentPage: "/documentPage",
  accountantExports: "/accountantExports",
  invitationModal: "/invitationModal",
  inviteAccept: "/invite/accept",
  usersPage: "/usersPage",
  clientProfilePage: "/clientProfilePage",
  documentViewerPage: "/documentViewerPage",
};

export const toastStatus = {
  success: "success",
  error: "error",
  warn: "warn",
  info: "info",
};
